import { getCookieData, sharePage } from '@repo/common-utils';
import { useWorkingPlatform } from '@repo/platform';
import { useUserEventLogger } from '@repo/tracking-service';
import { useDialog } from '@repo/ui';
import { List, useToast } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';

import FillRegisterCert from '@/assets/illust-icons/fill-register-cert.svg';
import { CHECK_DECISION_ACTION_CODE_COOKIE_KEY } from '@/components/tax-refund/common/data/result-refund-data';
import { 경정청구서비스공유주소2 } from '@/lib/constants/link';
import { 환급결정확인알림톡_PATH } from '@/lib/constants/paths';
import useSaveRefundActionLog from '@/lib/hooks/api/mutation/use-save-refund-action-log';
import useDetectOs from '@/lib/hooks/use-detect-os';

const JointCertificateSection = () => {
  const router = useRouter();
  const detectOS = useDetectOs();
  const { sendClickEvent } = useUserEventLogger();
  const { commit: saveActionLog } = useSaveRefundActionLog();
  const { showDialog } = useDialog();
  const { workingPlatform } = useWorkingPlatform();
  const toast = useToast();

  const handleClickCopy = () => {
    sharePage(
      {
        title: '개인/법인사업자 환급금 무료 조회 - 비즈넵 세금 환급',
        url: 경정청구서비스공유주소2
      },
      () => {
        toast({ content: '링크를 복사했습니다.', icon: 'check-mark', iconColor: 'green.600' });
      }
    );
  };

  const handleClickJointCertificate = () => {
    sendClickEvent('indis-talk-decision_selectauth_commoncert');

    if (detectOS === 'windows') {
      const actionCode = router.query.actionCode ?? getCookieData(CHECK_DECISION_ACTION_CODE_COOKIE_KEY);
      if (actionCode) {
        saveActionLog({ variables: { actionCode, actionStatus: '공동인증서요청' } });
      }
      router.push({
        pathname: `${환급결정확인알림톡_PATH.공동인증서설치판단}`,
        query: router.query
      });
    } else {
      showDialog({
        title: '윈도우 PC로 접속해주세요',
        description:
          workingPlatform === 'web'
            ? '공동인증서는 윈도우(Windows) PC에서만 사용할 수 있어요. 링크를 복사한 후 윈도우 PC에 접속해 이용해보세요.'
            : '공동인증서는 윈도우(Windows) PC에서만 사용할 수 있어요. 비즈넵 환급 웹사이트(https://bznav.com/tax/refund)를 통해 이용해주세요.',
        buttons: {
          primary: {
            text: workingPlatform === 'web' ? '접속 링크' : '확인',
            onClick: () => {
              if (workingPlatform === 'web') {
                handleClickCopy();
              }
            }
          }
        }
      });
    }
  };

  return (
    <>
      <List.Basic
        left={<FillRegisterCert width={36} height={36} />}
        title={{ text: '공동인증서로 진행하기', titleStyle: 'headline-18' }}
        subText={{ text: '홈택스에 등록된 대표자의 인증서로 진행해요.' }}
        listIcon
        onClick={handleClickJointCertificate}
        className="page-padding cursor-pointer"
      />
    </>
  );
};

export default JointCertificateSection;
